export default function accountTypeAvailable(channels, type) {
  const channelsOfThisType = (channels[type]) || [];
  return channelsOfThisType.length > 0;
}
